<template>
  <div id="app" style="padding-top: 40px;  height: 100vh; overflow: auto;" :style="{ 'background-image': `url(${coverImage})`, 'background-repeat': 'no-repeat', 'background-size': 'cover' }">
    <h1 style="font-size: 35px; color: white; text-align: left; margin-left: 80px; margin-top: -20px;">EILIS 智慧互動</h1>
    <br><br>
    <div class="board">
      <el-radio v-model="radio" label="1" border>手機號碼登入</el-radio>
      <el-radio v-model="radio" label="2" border>電子郵件登入</el-radio>
      <!-- <mu-avatar :size="120" style="position: relative;">
        <mu-icon value="account_circle" size="100"></mu-icon>
        <img v-if="avatarImg !== 'no'" :src="avatarImg" class="profilePhoto" @click="photoDia = true">
      </mu-avatar> -->
      <br><br>
      <mu-text-field icon="phone" placeholder="請輸入電話" v-model="phone" v-if="radio === '1'" style="width: 100%; margin-left: -20px"></mu-text-field>
      <mu-text-field icon="email" placeholder="請輸入Email" v-model="email" v-if="radio === '2'" style="width: 100%; margin-left: -20px"></mu-text-field>
      <mu-text-field icon="lock" placeholder="請輸入密碼" type="password"  v-model="password" style="width: 100%; margin-left: -20px"></mu-text-field>
      <br><br><br>
      <div style="position: absolute; left: 30px; bottom: 20px;">
        <span style="cursor: pointer;" @click="forgetPass">忘記密碼？</span>
      </div>
      <div style="position: absolute; right: 20px; bottom: 20px;">
        <el-button style="font-size: 18px; font-weight: 500; margin-left: 10px;" type="primary" @click="login">
          登入
        </el-button>
      </div>
    </div>
    <div class="ab">
      <mu-button flat class="register" @click="register">
        <mu-icon left value="person_add" style="transform: scale(0.8);"></mu-icon>註冊
      </mu-button>
    </div>
    <div class="bc">
      <mu-button flat class="register">
        <mu-icon left value="fingerprint" style="transform: scale(0.8);"></mu-icon>登入
      </mu-button>
    </div>
    <!-- dialog -->
    <el-dialog title="系統通知" :visible.sync="showReset" width="500px">
      <div style="margin-bottom: 10px;">請輸入註冊時的 Email</div>
      <el-input placeholder="你的 Email" v-model="resetEmail">
        <el-button slot="append" @click="resetPass" :disabled="count !== 0">{{ count !== 0 ? '重新發送 ' + count : '發送驗證信' }}</el-button>
      </el-input>
      <div style="color: #f24; margin-top: 10px; margin-bottom: 10px;" v-if="emailSent">{{ alertMsg }}</div>
    </el-dialog>
    <!-- dialog -->
    <el-dialog title="系統通知" :visible.sync="showReset2" width="500px">
      <mu-carousel :active="active" :hide-controls="true" :hide-indicators="true" :cycle="false" style="height: 100px;">
        <mu-carousel-item>
          <div style="margin-bottom: 10px;">請輸入註冊時的電話號碼</div>
          <el-input placeholder="你的手機號碼" v-model="resetPhone">
            <el-button slot="append" :disabled="count !== 0" @click="sendVer">發送驗證碼 {{ count === 0 ? '' : count }}</el-button>
          </el-input>
          <div v-if="errorText2" style="color: #f24; margin-top: 5px;">{{ errorText2 }}</div>
        </mu-carousel-item>
        <mu-carousel-item>
          <div style="margin-bottom: 10px;">請輸入驗證碼</div>
          <el-input v-model="verCode" placeholder="請輸入6位數字驗證碼"></el-input>
          <div v-if="errorText" style="color: #f24;">{{ errorText }}</div>
        </mu-carousel-item>
      </mu-carousel>
      <span slot="footer" class="dialog-footer" v-if="active === 1">
        <el-button type="info" @click="sendVer">重新發送 {{ count === 0 ? '' : count }}</el-button>
        <el-button type="primary" @click="checkCode">確認</el-button>
      </span>
    </el-dialog>
    <!-- dialog -->
    <el-dialog title="系統通知" :visible.sync="dialogMsg">
      <span>{{ result }}</span>
    </el-dialog>
    <!-- dialog -->
    <div style="position: fixed; bottom: 10px; left: 20px; text-align: left;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px; color: #fff;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Login',
  data() {
    return {
      avatarImg: localStorage.getItem('ProfileImg') ? localStorage.getItem('ProfileImg') : 'no',
      email: '',
      phone: '',
      radio: '1',
      resetEmail: '',
      resetPhone: '',
      password: '',
      verCode: '',
      errorText: '',
      errorText2: '',
      code: '',
      uid: '',
      active: 0,
      wrongPass: false,
      dialogMsg: false,
      showReset: false,
      emailSent: false,
      isLoading: false,
      showReset2: false,
      coverImage: '',
      count: 0,
      alertMsg: '',
      result: '登入中...',
      countryCode: '+886',
      phoneNumber: '0987187187',
      images: [
        'https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        'https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
        'https://images.unsplash.com/photo-1487429137302-846063489702?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1352&q=80',
        'https://images.unsplash.com/photo-1542395403839-388ec538e0e5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1351&q=80',
        'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1355&q=80',
        'https://images.unsplash.com/photo-1462826303086-329426d1aef5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        'https://images.unsplash.com/photo-1497366858526-0766cadbe8fa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
        'https://images.unsplash.com/photo-1473445361085-b9a07f55608b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1384&q=80',
        'https://images.unsplash.com/photo-1482440308425-276ad0f28b19?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
        'https://images.unsplash.com/photo-1500565468401-c273cdd7a5ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1301&q=80',
        'https://images.unsplash.com/photo-1431540015161-0bf868a2d407?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
      ],
    };
  },
  mounted() {
    this.coverImage = this.images[Math.floor(Math.random() * this.images.length)];
    this.phone = '';
    this.email = '';
    this.checkUser();
  },
  computed: {
    ...mapGetters({
      userID: 'userid',
      userName: 'username',
    }),
    redirectUrl() {
      return `https://eilis-app.herokuapp.com/`;
    },
    querydata() {
      return `${this.phoneNumber}&Auth=123&Token=123`;
    }
  },
  methods: {
    ...mapMutations({
      getUser: 'getUser',
    }),
    ...mapActions({
      getUserDetail: 'getUserDetail',
      getUserByEmail: 'getUserByEmail',
      userLogin: 'userLogin',
      sendEmail: 'sendEmail',
      sendSMS: 'sendSMS'
    }),
    forgetPass() {
      if (this.radio === '2') {
        this.phone = '';
        this.emailSent = false;
        this.showReset = true;
      }
      else {
        this.email = '';
        this.resetPhone = '';
        this.errorText2 = '';
        this.errorText = '';
        this.active = 0;
        this.showReset2 = true;
      }
    },
    countDown() {
      this.count = 60;
      setInterval(() => {
        if (this.count > 0) {
          this.count -= 1
        }
      }, 1000)
    },
    sendVer() {
      this.countDown();
      const random = new Array('0','1','2','3','4','5','6','7','8','9');
      let code = '';
      for (let e = 0; e < 6; e += 1) {
        const index = Math.floor(Math.random() * 10);
        code += random[index];
      }
      this.code = code;
      this.getUserByEmail({ phone: this.resetPhone }).then((res) => {
        if (res.data.uid) {
          this.uid = res.data.uid;
          this.sendSMS({ phone: this.resetPhone, code: code }).then(() => {
            this.active = 1;
          })
        }
        else {
          this.errorText2 = '此電話尚未註冊';
        }
      })
    },
    checkCode() {
      if (this.verCode) {
        if (this.verCode === this.code) {
          this.errorText = '';
          this.$router.push(`/resetPass?uid=${this.uid}`);
        }
        else {
          this.errorText = '驗證碼輸入錯誤';
        }
      }
      else {
        this.errorText = '請輸入6位數字驗證碼';
      }
    },
    resetPass() {
      if (this.resetEmail) {
        this.count = 60;
        setInterval(() => {
          if (this.count > 0) {
            this.count -= 1
          }
        }, 1000)
        const loading = this.$loading({
          lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
        });
        this.getUserByEmail({ email: this.resetEmail }).then((res) => {
          const uid = res.data.uid;
          if (uid) {
            this.sendEmail({ email: this.resetEmail, uid: uid }).then(() => {
              loading.close();
              this.emailSent = true;
              this.alertMsg  = `已發送密碼重置連結至 ${this.resetEmail}，請前往收信，若沒收到可於 60 秒後重新驗證。`;
            })
          }
          else {
            loading.close();
            this.emailSent = true;
            this.alertMsg  = '該 Email 尚未有人註冊';
          }
        })
      }
      else {
        this.emailSent = true;
        this.alertMsg  = '請輸入 Email';
      }
      // }
    },
    checkUser() {
      const loading = this.$loading({
        lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
      });
      this.getUserDetail().then((res) => {
        if (res.data.detail) {
          localStorage.setItem('MemberData', JSON.stringify(res.data.detail));
          this.$router.push('/mainpage');
          loading.close();
        }
        else {
          loading.close();
        }
      })
    },
    login() {
      if (this.password) {
        if (this.radio === '1' && !this.phone) {
          alert('有資料漏填囉！');
        }
        else if (this.radio === '2' && !this.email) {
          alert('有資料漏填囉！');
        }
        else {
          this.dialogMsg = true;
          if (this.radio === '1') {
            this.userLogin({ Email: '', Phone: this.phone, Password: this.password })
              .then((res) => {
                if (res.data.uid) {
                  localStorage.setItem('UserID', res.data.uid);
                  localStorage.setItem('lastLogin', res.data.lastLoginAt);
                  this.$router.push('/mainpage');
                }
                else {
                  this.dialogMsg = false;
                  alert('登入失敗，請輸入正確帳號密碼');
                }
              })
          }
          else {
            this.userLogin({ Email: this.email, Phone: '', Password: this.password })
              .then((res) => {
                if (res.data.uid) {
                  localStorage.setItem('UserID', res.data.uid);
                  localStorage.setItem('lastLogin', res.data.lastLoginAt);
                  this.$router.push('/mainpage');
                }
                else {
                  this.dialogMsg = false;
                  alert('登入失敗，請輸入正確帳號密碼');
                }
              })
          }
        }
      }
      else {
        alert('有資料漏填囉！');
      }
    },
    register() {
      this.$router.push('/');
    },
  },
}
</script>

<style scoped>
.board {
  padding: 40px 20px;
  position: relative;
  border-radius: 8px;
  margin: 0px auto;
  max-width: 400px;
  min-width: 400px;
  background-color: rgba(255, 255, 255, 0.945);
  -webkit-animation-name: myframes;
          animation-name: myframes;
  -webkit-animation-duration: 500ms;
          animation-duration: 500ms;
  -webkit-animation-timing-function: ease-in-out;
          animation-timing-function: ease-in-out;
  -webkit-animation-delay: 0s;
          animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
          animation-iteration-count: 1;
  -webkit-animation-direction: normal;
          animation-direction: normal;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;
}
.box.is-paused {
  -webkit-animation-play-state: paused;
          animation-play-state: paused;

}
@keyframes myframes {
  0% {
    -webkit-transform: scale(0) rotate(0deg);
            transform: scale(0) rotate(0deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: scale(1) rotate(0deg);
            transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}
.register {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  width: 100px;
}
.el-input-group__prepend {
  width: 60px;
  background-color: #777;
  color: #fff;
  font-weight: 500;
  font-size: 15px;
}
.ab {
  position: absolute;
  top: 20px;
  right: 70px;
}
.bc {
  position: absolute;
  top: 20px;
  right: 160px;
}
</style>
